import axios from 'axios';

export async function listEntries(path = '/', deletedMode = 'exclude', recursive = true): Promise<unknown> {
    const response = await axios.get('/api/library/ls', {
        params: { path, deletedMode, recursive },
    });
    return response.data;
}

export async function restoreEntry(id: string): Promise<unknown> {
    return await axios.post('/api/library/restore', null, { params: { id } });
}

export async function deleteFolder(path: string): Promise<unknown> {
    return await axios.delete('/api/library/rmdir', { params: { path } });
}

export async function deleteEntry(id: string): Promise<unknown> {
    return await axios.delete('/api/library/rm', { params: { id } });
}

export async function moveEntry(id: string, path: string): Promise<unknown> {
    return await axios.put('/api/library/mv', null, { params: { id, path } });
}

export async function copyEntry(id: string, path: string, recursive = false): Promise<unknown> {
    const params: { id: string; path: string; recursive?: boolean } = { id, path };
    if (recursive) {
        params.recursive = true;
    }
    return await axios.post('/api/library/cp', null, { params });
}

export async function createFolder(path: string, folder: string): Promise<unknown> {
    return await axios.post('/api/library/mkdir', null, { params: { path, folder } });
}

export async function exportEntry(path: string): Promise<Blob> {
    const response = await axios.get('/api/vue/download', {
        params: { path },
        responseType: 'blob',
    });
    return response.data as Blob;
}

export async function transferOwnership(id: string, campaignId: string, newOwnerId: string): Promise<unknown> {
    try {
        const response = await axios.post('/api/library/chown', { id, campaignId, newOwnerId });
        return response.data;
    } catch (err: unknown) {
        const e = err as { response?: { data?: { message?: string } }; message?: string };
        throw new Error(e?.response?.data?.message || e?.message || 'Transfer failed');
    }
}

/**
 * Rename a library item in-place.
 * @param id   The item's _id.
 * @param name The new display stem — no extension.  The server preserves the existing extension.
 * @throws Error with a user-readable message on failure.
 */
export async function renameEntry(id: string, name: string): Promise<unknown> {
    try {
        return await axios.patch('/api/library/rename', { id, name });
    } catch (err: unknown) {
        const e = err as { response?: { data?: { message?: string } }; message?: string };
        throw new Error(e?.response?.data?.message || e?.message || 'Rename failed');
    }
}
